import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Client } from "./API/client";
import { toastrService } from "./ux/toastr.service";

export interface Account {
  walletId: number
  currencyId: number | null
  balanceMoney: number | null
  isBlocked: boolean | null
  lastDebitDate: string | null
  lastCreditDate: string | null
  pendingAmount: number | null
  debitInfo: string | null
  creditInfo: string | null
  createdAt: string | null
  iban: string | null
  accountStatus: string | null
  accountDescription: string | null
  currencyCode: string
}

@Injectable()
export class AccountService {
  private accountSource = new BehaviorSubject<Account[]>([]);
  accounts = this.accountSource.asObservable();

  constructor(private api: Client, private toastr: toastrService) { }

  public async getAccounts() {
    try {
      const data = await this.api.get("api/user/wallet-overview")
      this.accountSource.next(data as Account[])
    } catch (err) {
      this.toastr.error(err)
    }
  }

  public async GetShortUuid() {
    try {
      const data = await this.api.get("api/user/short-uuid")
      return data
    } catch (err) {
      this.toastr.error(err)
    }
  }

  public async checkProfileIsVerified() {
    try {
      const data = await this.api.post('api/user/check-authorization')
      return data
    } catch (err) {
      this.toastr.error(err)
    }
  }

  public async updateAccount(data: any) {
    try {
      await this.api.post("api/user/update-wallet-overview", data)
    } catch (err) {
      this.toastr.error(err)
    }
  }
}
